"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToApiFilters = exports.useTableData = void 0;
const common_types_1 = require("../../../common/common-types");
const table_types_1 = require("../table-types");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const first_render_1 = require("../../../utils/first-render");
const update_effect_1 = require("../../../utils/update-effect");
const force_render_1 = require("../../../utils/force-render");
function useTableData({ source, searchQuery, sorts, preFilters, filters, filtersState, include, loaderRef, }) {
    const { forceRender } = force_render_1.useForceRender();
    const setSourceParams = event_callback_hook_1.useEventCallback(() => {
        const filtersWithState = filters.map((filter, i) => ({ ...filter, ...filtersState[i] }));
        source.setParams({
            sort: convertToApiSorts(sorts),
            filters: convertToApiFilters(preFilters, filtersWithState, searchQuery),
            include: include,
            size: 30,
        });
    });
    first_render_1.useFirstRender(() => {
        setSourceParams();
    });
    update_effect_1.useUpdateEffect(() => {
        setSourceParams();
        source.reset();
        forceRender();
        requestAnimationFrame(() => {
            var _a;
            (_a = loaderRef.current) === null || _a === void 0 ? void 0 : _a.resetloadMoreItemsCache(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, sorts, preFilters, filtersState, include]);
}
exports.useTableData = useTableData;
function convertToApiSorts(sorts) {
    return sorts.map((sort) => ({
        field: sort.field,
        order: sort.order,
        type: sort.type,
    }));
}
/**
 * Translares table filters to api filters.
 *
 * Combines pre-filters, table filters with search query, removes disabled or empty filters
 * @param preFilters
 * @param filters
 * @param searchQuery
 */
function convertToApiFilters(preFilters, filters, searchQuery) {
    const apiFilters = filters
        .filter((filter) => filter.enabled)
        .filter(filterEmptyFilter)
        .map((filter) => {
        const { operation, filterkey, value, filters } = filter;
        return {
            field: filterkey,
            operation: operation,
            value,
            filters,
        };
    });
    if (searchQuery !== '') {
        apiFilters.push({
            field: '',
            operation: common_types_1.ApiFilterOperation.FTX,
            value: searchQuery,
        });
    }
    if (preFilters.length) {
        apiFilters.push(...preFilters.filter(({ value }) => !!value));
    }
    return apiFilters;
}
exports.convertToApiFilters = convertToApiFilters;
function filterEmptyFilter({ value, operation }) {
    if (value == null && operation === table_types_1.TableFilterOperation.EQ) {
        return false;
    }
    return true;
}
//# sourceMappingURL=table-data-hook.js.map